
import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ScrAuthenticationService } from 'src/app/services/authentication.service';
import { ScrAuthorizationService } from 'src/app/services/authorization.service';
import { PendingOrderService } from 'src/app/services/pendingorder.service';
import { ScrBaseComponent } from '../../base.component';
import { ConfigService } from '../../../services';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends ScrBaseComponent implements OnInit {

  public displaySessionExpirationDialog = false;
  public displayResetPasswordDialog = false;

  loginCredentials = {
    username: '',
    password: '',
  };

  @ViewChild('passwordField', { static: false }) passwordField?: ElementRef;
  @ViewChild('loginForm', { static: false }) loginForm?: NgForm;

  constructor(
    protected authenticationService: ScrAuthenticationService,
    protected authorizationService: ScrAuthorizationService,
    private router: Router,
    private config: ConfigService,
    private pendingOrderService: PendingOrderService) {
    super();
  }

  ngOnInit(): void {

    if (history.state?.tokenexpired) {
      this.router.navigate(['/sec/login']);
      return;
    }

    if ((this.router.url === '/sec/logout') || (this.router.url === '/sec/inactivitylogout') || (this.router.url === '/sec/linkedsessiontimeout')) {
      const displayTokenExpired = !!history.state.displayTokenExpired;

      this.authenticationService.logout(displayTokenExpired).then(() => {
        this.log.debug('logout completed');
        localStorage.removeItem('ngStorage-userId');
        this.router.navigate(['/sec/login']);
      }).catch(() => {
        this.router.navigate(['/sec/login']);
      });
    }
    else {
      // ok, user is attempting to navigate to the login page.
      // are they already logged in?  If so, they have bookmarked the login
      // page but we should probably take them to their default landing page.
      this.routePostLogin();
    }

    const authState = this.authenticationService.getAuthState();
    if (authState && 'tokenExpiration' === authState.stateQualifier) {
      this.displaySessionExpirationDialog = true;
    }

    if (this.authenticationService.suggestedUserName) {
      this.loginCredentials.username = this.authenticationService.suggestedUserName;
      this.authenticationService.suggestedUserName = undefined;
    }
  }

  @HostListener('document:click', ['$event'])
  documentClick() {
    this.config.checkForUpdate();
  }

  submit(): void {
    this.clearMessages();
    if (this.loginForm?.valid) {
      this.observe(this.authenticationService.submitLogin(this.loginCredentials.username, this.loginCredentials.password), {
        onFailure: (rsp => {
          if (rsp.messages) {
            if (rsp.messages.some(m => m.code === '1121')) {
              this.displayResetPasswordDialog = true;
              return false;
            }
          }
          return true;
        }),
        onSuccess: (rsp => {
          this.analyticsService.emitLogin(rsp.user?.userId, rsp.user?.accountId);
          this.routePostLogin();
          localStorage.setItem('ngStorage-userId', String(rsp.user?.userId));
          return false; // don't display success message.
        })
      });
    }
  }

  private routePostLogin(): void {

    // did the user try to go to a page and get redirected to the login page first?
    if ((this.authenticationService.redirectUrl) && (this.authenticationService.redirectUrl !== '')) {
      const urlTree = this.router.parseUrl(this.authenticationService.redirectUrl);
      this.router.navigateByUrl(urlTree);
      this.authenticationService.redirectUrl = '';
      return;
    }

    const cartCount = this.pendingOrderService.getCartCount();
    this.authorizationService.routeUserPostLogin(cartCount);
  }

  public redirectToForgotPassword(): void {
    this.router.navigateByUrl('/sec/forgotpassword');
  }

  showPass(pw: HTMLInputElement): void {
    pw.type = pw.type === 'password' ? 'text' : 'password';
  }

}
